'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormGroup = require('react-bootstrap/lib/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FormGroup2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/FormGroup.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/FormGroup.js
 ** module chunks = 0
 **/